import React from 'react';
import { Grid, Card, CardContent, Typography } from '@mui/material';

const TaskStatusSummary = ({ taskStatusCounts }) => {
  const activeTasks = taskStatusCounts.PENDING + taskStatusCounts.PROCESSING;
  const totalTasks = Object.values(taskStatusCounts).reduce((sum, count) => sum + count, 0);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Typography color="text.secondary" gutterBottom>
              Active Tasks
            </Typography>
            <Typography variant="h3">
              {activeTasks}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {taskStatusCounts.PENDING} pending, {taskStatusCounts.PROCESSING} processing
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Typography color="text.secondary" gutterBottom>
              Completed Tasks
            </Typography>
            <Typography variant="h3">
              {taskStatusCounts.COMPLETED + taskStatusCounts.VALIDATED}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {taskStatusCounts.VALIDATED} validated
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Typography color="text.secondary" gutterBottom>
              Failed Tasks
            </Typography>
            <Typography variant="h3" color="error.main">
              {taskStatusCounts.FAILED}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Requires attention
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Typography color="text.secondary" gutterBottom>
              Total Tasks
            </Typography>
            <Typography variant="h3">
              {totalTasks}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              All time
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default TaskStatusSummary;